import React from 'react';
import { Link } from 'gatsby';
import { Transition } from 'react-transition-group';

import IconButton from '../SVGs/IconButton';
import { useCart } from '../../contexts/CartContext';
import CartItem from './CartItem';
import { formatPrice } from '../../utils';

const Index = () => {
  const { cartData, getGrossCartTotal, cartOpen, closeCartOverlay } = useCart();

  const duration = 300;

  const defaultStyle = {
    transition: `transform ${duration}ms ease-in-out`,
    transform: 'translateX(100%)',
  };

  const transitionStyles = {
    entering: { transform: 'translateX(0)' },
    entered: { transform: 'translateX(0)' },
    exiting: { transform: 'translateX(100%)' },
    exited: { transform: 'translateX(100%)' },
  };

  return (
    <>
      <Transition in={cartOpen} timeout={duration}>
        {(state) => (
          <section
            className={`
              absolute_ fixed right-0 z-50 h-screen bg-dnd-dark flex flex-col w-full divide-y divide-solid divide-white lg:w-[550px]
            `}
            style={{
              ...defaultStyle,
              ...transitionStyles[state],
            }}
          >
            <div className="flex justify-between px-6 pb-6 pt-[42px] lg:pt-[72px] lg:px-14">
              <h3 className="font-benguiat font-bold text-dnd-yellow text-_3628 uppercase">
                Your Cart ({cartData?.length})
              </h3>
              <div onClick={closeCartOverlay}>
                <IconButton
                  icon="close"
                  iconColor="#FFA200"
                  backgroundColor="transparent"
                  hoverTextColor="#FF0000"
                  size="lg"
                />
              </div>
            </div>

            <div id='cart-items' className="px-6 lg:px-14 overflow-y-auto">
              {cartData?.map((item, index) => (
                <CartItem key={index} item={item} />
              ))}
            </div>

            <div className="py-10 flex justify-end pr-14 mt-auto">
              <table className="table-fixed w-3/4">
                <tbody>
                  <tr className="text-white font-inter text-_1822 font-medium">
                    <td>Shipping</td>
                    <td className="text-right">Calculated later</td>
                  </tr>
                  <tr className="text-white font-inter text-_1822 font-medium">
                    <td>Subtotal</td>
                    <td className="text-right">{formatPrice(getGrossCartTotal())}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="bg-dnd-yellow py-7 text-center ">
              {cartData?.length > 0 ? (
                <Link 
                  to="/checkout" 
                  className="text-dnd-dark font-benguiat uppercase font-bold text-_3636 select-none"
                >
                  Proceed to checkout
                </Link>
              ) : (
                <span className="text-dnd-dark font-benguiat uppercase font-bold text-_3636 opacity-50 cursor-not-allowed select-none">
                  Proceed to checkout
                </span>
              )}
            </div>
          </section>
        )}
      </Transition>
    </>
  )
}

export default Index